import { NoAvailabilitiesInfo } from '@/app/_components/widgets/listing/cardV3/NoAvailabilitiesInfo';
import { useIsDesktop } from '@/app/_hooks/useIsScreen';
import { posthogTracker } from '@/utils/trackingPostHog';
import { ELButton } from '@davincihealthcare/elty-design-system-react';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { useCallCenterPhoneNumbers } from '@/app/_hooks/useCallCenterPhoneNumbers';

export const BookingActions: React.FC<{
  onClick: () => void;
  showPhoneNumber?: boolean;
  onNoAvailabilitiesClick: () => void;
  hasAvailableSlots: boolean;
}> = ({ onClick, showPhoneNumber = true, hasAvailableSlots, onNoAvailabilitiesClick }) => {
  const isDesktopAndBigger = useIsDesktop({ andSmaller: false });
  const { prefixedNumber, formattedNumber } = useCallCenterPhoneNumbers();

  if (!hasAvailableSlots)
    return (
      <NoAvailabilitiesInfo
        title="Al momento non ci sono orari disponibili"
        description="Vedi tutte le prestazioni"
        onClick={onNoAvailabilitiesClick}
      />
    );

  return (
    <div className="flex flex-col justify-center gap-3 md:items-center">
      <ELButton
        trailingIcon={<ArrowRightIcon />}
        color="primary"
        variant="filled"
        size={isDesktopAndBigger ? 'medium' : 'large'}
        label="Scegli giorno e ora"
        onClick={onClick}
      />

      {showPhoneNumber && (
        <div className="w-full self-center text-ellipsis py-3 text-center text-base font-normal text-primary lg:py-0">
          <>
            oppure chiama il{' '}
            <a
              className="whitespace-nowrap text-base font-semibold underline"
              onClick={() => {
                if (!isDesktopAndBigger) {
                  posthogTracker.captureMobilePhoneClick();
                }
              }}
              href={`tel:${prefixedNumber}`}
            >
              {formattedNumber}
            </a>
          </>
        </div>
      )}
    </div>
  );
};
